export default function offsetAnchor($anchor) {

  let targetId = $anchor.getAttribute('data-offset-target')
  if (targetId) {
    let $target = document.getElementById(targetId)
    if ($target) {
      $anchor.setAttribute('style', 'position: absolute; top: -' + $target.offsetHeight + 'px')
      window.addEventListener('scroll', e => {
        $anchor.style.top = '-' + $target.offsetHeight + 'px'
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/ui/offset-anchor.js